import { tns } from 'tiny-slider/src/tiny-slider';

class FeaturedBannerSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		this.slider = tns({
			container: this.el,
			fixedWidth: 320,
			gutter: 20,
			center: true,
			loop: true,
			autoplay: true,
			autoplayButtonOutput: false,
			autoplayTimeout: 5000,
			speed: 600,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			responsive: {
				641: {
					fixedWidth: 360,
					gutter: 24
				},
				1025: {
					fixedWidth: 400,
					gutter: 28
				}
			}
		});
	}
}

export default FeaturedBannerSlider;
